<script setup lang="ts">
import { type Component, onUpdated, ref, type Ref } from 'vue';
import { useTopDialogSelf } from '@/components/dialog/dialog/composables/utils';
import type { Props } from './types';

const props = withDefaults(defineProps<Props>(), {
	keepAlive: true,
});

const dialog = useTopDialogSelf();

/**
 * Статус загрузи асинхронного компонента страницы диалогового окна
 */
const updateIsLoadingAsyncPage = (component: Component, isLoaded: Ref) => {
	if (isLoaded.value) return;

	if (component.name !== 'AsyncComponentWrapper') {
		isLoaded.value = true;

		return;
	}

	if (!dialog.needShowPage(props.name as string)) return;

	dialog.isLoadingPage.value = true;

	// @ts-ignore
	if (component.__asyncResolved) {
		isLoaded.value = true;

		dialog.isLoadingPage.value = false;
	}
};

if (props.component.name === 'AsyncComponentWrapper') {
	const isLoaded = ref(false);

	onUpdated(() => {
		updateIsLoadingAsyncPage(props.component, isLoaded);
	});
}
</script>

<template>
	<!-- Teleport внутри при keepAlive размонитроваться не будет, см. TopDialogPage -->
	<KeepAlive :include="keepAlive ? '' : 'none'">
		<Component
			:is="component"
			v-if="dialog.needShowPage(name)"
			:="props"
			:name="name"
			:order="order"
			:prevName="prevName"
		/>
	</KeepAlive>
</template>
